import dayjs from "dayjs";
import logger from "../../../utils/logger";
import { chantApi } from "../../../utils/chantApi";

export const fetchParentGalleryImages = async ({
  parentId,
  selectedGroupIds,
  dateRange,
  pageParam = null,
}) => {
  try {
    if (!parentId || selectedGroupIds.length === 0) {
      return {
        images: [],
        hasMore: false,
        lastDocId: null,
        lastGroupId: null,
        lastUploadDate: null,
      };
    }

    const reqBody = {
      parentId: parentId,
      groupIds: selectedGroupIds,
      limit: 30,
      lastDocId: pageParam?.lastDocId || null,
      lastGroupId: pageParam?.lastGroupId || null,
      lastUploadDate: pageParam?.lastUploadDate || null,
      startDate: dateRange?.[0] ? dayjs(dateRange[0]).unix() : null,
      endDate: dateRange?.[1] ? dayjs(dateRange[1]).unix() : null,
    };

    const response = await chantApi.post(
      `${import.meta.env.VITE_GCP_BASE_URL}/gallery/images/parent`,
      reqBody
    );

    // Handle the nested response structure
    const responseData = response.data?.data || {};
    const pagination = responseData.pagination || {};

    return {
      images: responseData.images || [],
      hasMore: pagination.hasMore || false,
      lastDocId: pagination.lastDocId || null,
      lastGroupId: pagination.lastGroupId || null,
      lastUploadDate: pagination.lastUploadDate || null,
    };
  } catch (error) {
    logger.error("Error fetching parent gallery images:", error);
    throw error;
  }
};
